import { WORKFLOW_FIELDS } from '../fragments'

export default `
  ${WORKFLOW_FIELDS}
  mutation cloneWorkflow($workflowId: String!, $projectId: String!) {
    cloneWorkflow(workflowId: $workflowId, projectId: $projectId) {
      ...WorkflowFields
    }
  }
`
